import React from 'react'

export default function PageNotLoaded() {
  return (
    <div>
    <h1 className="pt-4 text-center">Page Not Found</h1>
    <p className="text-center">Please navigate back!!!</p>
  </div>
  )
}
